import { useState } from 'react';

import TableComponent from 'app/components/Table/TableComponent';
import { DEFAULT_TABLE_QUERY, QUERIES } from 'app/components/Table/core/constants';
import { TYPE_MODAL } from 'app/components/Table/core/types';
import RootContentPage from 'app/components/layout/RootContentPage';

import { Organizations } from 'app/modules/organizations/core/type';

import { useSyncQueryToState } from '../query-state/hooks';
import { organizationsRoleColumns } from './core/columns';
import { deleteOrg, getOrganizations, restoreOrg } from './core/requests';
import { FormOrganizationTableCard } from './modal/FormOrganizationTableCard';
import { useOrganizationStore } from 'theme/layout/components/aside/store';

const OrganizationsManagementPage = () => {
  const [organization, setOrganization] = useState<Organizations>();
  const [refetchTimestamp, setRefetchTimestamp] = useState(0);

  useSyncQueryToState(window.location.pathname, DEFAULT_TABLE_QUERY);

  const renderModalForm = (originalData: any, _typeModal: TYPE_MODAL, isView?: boolean) => {
    return (
      <FormOrganizationTableCard
        organization={originalData}
        titleNotification="Organization"
        originIsView={isView}
      />
    );
  };

  const handleGetDataItem = (item: Organizations) => setOrganization(item);

  const handleRestoreOrg = async (item: Organizations) => {
    const isSuccess = await restoreOrg(item.id);

    if (isSuccess) {
      setRefetchTimestamp(refetchTimestamp + 1);

      const prevOrganizationList = useOrganizationStore.getState().getOrganizationList();
      useOrganizationStore
        .getState()
        .setOrganizationList([
          ...prevOrganizationList,
          { id: item.id, name: item.name, logo: item.logo },
        ]);
    }
  };

  return (
    <RootContentPage title="Organizations">
      <TableComponent
        originColumns={organizationsRoleColumns(handleRestoreOrg)}
        nameQuery={QUERIES.ORGANIZATION_LIST}
        moreQuery="&withDeleted=true"
        getList={getOrganizations}
        ModalForm={renderModalForm}
        deleteById={deleteOrg}
        titleModal="Organization"
        contentModal={
          <>
            You are deleting <b>{organization?.name}</b> organization. Deleting this Organization
            will also delete its related data.
          </>
        }
        nameBtnAdd="Add Organization"
        placeholderSearch="Search with name"
        isBorder={false}
        syncParamUrl
        spacing="lg"
        isShowConfirmDelete
        getDataItem={handleGetDataItem}
        refetchTimestamp={refetchTimestamp}
      />
    </RootContentPage>
  );
};

export default OrganizationsManagementPage;
